import { MENU_COMEDOR_SEDE } from 'src/common/menuComedor';
import { MenuComedorState, selectAll, selectEntities } from './menu-comedor.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const menuComedorState = createFeatureSelector<MenuComedorState>("menu-comedor");

export const menuComedorAll = createSelector(
	menuComedorState,
	selectAll
);

const menuComedorSelectEntities = createSelector(
	menuComedorState,
	selectEntities
)

export const menuComedorSede = createSelector(
	menuComedorSelectEntities,
	menus => ( sede: MENU_COMEDOR_SEDE ) => menus[sede]
)

export const menuComedorReady = createSelector(
	menuComedorState,
	state => state.ready
)

export const menuComedorOnInit = createSelector(
	menuComedorState,
	state => state.onInit
)

export const menuComedorSedeSelected = createSelector(
	menuComedorState,
	state => state.sedeSelected
)
